module.exports = __webpack_public_path__ + "img/map_bg.58f3d8e6.png";